export default "__VITE_ASSET__Ev9xX5Jv__"